import { render, staticRenderFns } from "./userLimitConfig.vue?vue&type=template&id=ea8fb442&scoped=true&"
import script from "./userLimitConfig.vue?vue&type=script&lang=js&"
export * from "./userLimitConfig.vue?vue&type=script&lang=js&"
import style0 from "./userLimitConfig.vue?vue&type=style&index=0&id=ea8fb442&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8fb442",
  null
  
)

export default component.exports